export default class SolutionLightboxController {
  /* @ngInject */
  constructor(DictionaryService, ConfigurationService, $log) {
    this.solutionDictionaryLookup = DictionaryService.solutionDictionaryLookup;
    this.authorable = ConfigurationService.getConfiguration();
    this.$log = $log;
  }
  $onInit() {
    // prepare values to feed into component
    const parent = this.resolve.parentSolution;
    this.childSolutions = angular.copy(parent.children);
    this.lightboxFormData = angular.copy(this.resolve.formData);
    this.title = this.solutionDictionaryLookup(parent.key, 'name');
    this.description = this.solutionDictionaryLookup(parent.key, 'text');
  }
  applySolutions() {
    this.close(
      {
        $value: {
          lightboxFormData: this.lightboxFormData
        }
      }
    );
  }
  cancel() {
    this.dismiss(
      {
        $value: 'cancel'
      }
  );
  }
}



// WEBPACK FOOTER //
// ./src/components/search-form/solution-lightbox/solutionLightbox.controller.js